<template>
  <header class="user-header">
    <!-- 左上角：汉堡按钮 + 下拉菜单 -->
    <div class="hamburger" v-click-outside="closeMenu">
      <button class="hamburger-btn" @click="toggleMenu">
        <span class="line" />
        <span class="line" />
        <span class="line" />
      </button>


      <transition name="fade">
        <ul v-show="menuVisible" class="dropdown">
          <li v-for="it in menuList" :key="it.name" @click="handleMenuSelect(it)">
            <img class="icon-left" :src="it.icon" alt="" />
            <span class="txt">{{ it.name }}</span>
            <img class="icon-right" src="./assets/img/arrow-right.png" alt="" />
          </li>
        </ul>
      </transition>
    </div>

    <!-- 右上角：头像登录按钮 -->
    <div class="user-info" @click="handleUserClick">
      <div class="avatar-container">
        <img v-if="displayAvatar && displayAvatar !== require('./assets/img/avatar.png')" :src="displayAvatar" class="avatar" alt="avatar" referrerpolicy="no-referrer" />
        <div v-else class="avatar-placeholder">{{ displayGreeting.charAt(0) === 'H' ? 'U' : displayGreeting.charAt(0) }}</div>
      </div>
      <span class="text">{{ displayGreeting }}</span>
      
      <!-- 已登录状态下显示下拉箭头和菜单 -->
      <template v-if="isLoggedIn">
        <i class="el-icon-arrow-down" :class="{ 'rotate': showUserMenu }"></i>
        
        <!-- 用户下拉菜单 -->
        <div v-if="showUserMenu" class="user-dropdown-menu">
          <div class="menu-item" @click="switchAccount">
            <i class="el-icon-refresh"></i>
            <span>切换账号</span>
          </div>
          <div class="menu-item" @click="logout">
            <i class="el-icon-switch-button"></i>
            <span>退出登录</span>
          </div>
        </div>
      </template>
    </div>
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getToken } from '@/store/local/auth'
export default {
  name: 'UserHeader',
  props: {
    avatarUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      menuVisible: false,
      showUserMenu: false,
      menuList: [
        { name: '返回首页', icon: require('./assets/img/ic-home.png') },
        { name: '个人资料', icon: require('./assets/img/ic-user.png') },
        { name: '消息提醒', icon: require('./assets/img/ic-notice.png') },
        { name: '面试记录', icon: require('./assets/img/ic-interview.png') },
        { name: '简历管理', icon: require('./assets/img/ic-resume.png') },
        { name: '机会获取', icon: require('./assets/img/ic-opportunity.png') },
        { name: '意见反馈', icon: require('./assets/img/ic-feedback.png') }
      ],
      // 从 localStorage 读取到的用户信息
      localUser: {
        name: '',
        avatar: ''
      }
    }
  },
  computed: {
    ...mapState('user', ['name', 'avatar']),
    isLoggedIn() {
      // 检查是否有token或用户信息来判断登录状态
      const token = getToken()
      const hasUserInfo = this.localUser.name || this.name
      return !!(token && hasUserInfo)
    },
    displayAvatar() {
      // 优先 localStorage，其次全局用户头像，再其次 prop，最后默认头像
      return (
        this.localUser.avatar ||
        this.avatar ||
        this.avatarUrl ||
        require('./assets/img/avatar.png')
      )
    },
    displayGreeting() {
      const n = this.localUser.name || this.name
      return n ? `Hi, ${n}!` : 'Hi, 请登录'
    }
  },
  created() {
    // 若存在 token 且还未加载到用户信息，则尝试拉取
    const token = getToken()
    // 先尝试从 localStorage 获取
    try {
      const raw = window.localStorage.getItem('userInfo')
      if (raw) {
        const info = JSON.parse(raw)
        const candidateName = info.nickname || info.real_name || info.account || info.mobile || ''
        this.localUser = {
          name: candidateName,
          avatar: info.avatar || ''
        }
      }
    } catch (e) {
      // ignore
    }
    if (token && (!this.name || !this.avatar)) {
      this.fetchUserInfoSafely()
    }
  },
  mounted() {
    // 监听其他标签页对 localStorage 的更新
    window.addEventListener('storage', this.handleStorageChange)
    
    // 添加点击外部关闭用户菜单的事件监听器
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageChange)
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    ...mapActions('user', ['getInfo']),
    async fetchUserInfoSafely() {
      try {
        await this.getInfo()
      } catch (e) {
        // 静默失败，维持默认显示
      }
    },
    handleLoginTrigger() {
      // 未登录则跳转到登录页；已登录则前往个人资料
      const token = getToken()
      if (!token) {
        this.$router.push('/store/entry/loginPwd')
        return
      }
      this.$router.push('/store/dashboard/profile')
    },
    handleStorageChange(e) {
      if (e.key === 'userInfo') {
        try {
          const info = e.newValue ? JSON.parse(e.newValue) : null
          const candidateName = info && (info.nickname || info.real_name || info.account || info.mobile || '')
          this.localUser = info
            ? { name: candidateName, avatar: info.avatar || '' }
            : { name: '', avatar: '' }
        } catch (_) {}
      }
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible
    },
    closeMenu() {
      this.menuVisible = false
    },
    handleMenuSelect(item) {
      const name = item && item.name
      switch (name) {
        case '返回首页':
          this.$router.push('/')
          break
        case '个人资料':
          this.$message.info('功能正在维护中')
          break
        case '消息提醒':
          this.$router.push('/chating')
          break
        case '面试记录':
          this.$router.push('/interview_mianshilishi')
          break
        case '简历管理':
          this.$router.push('/resume_manage')
          break
        case '机会获取':
          this.$router.push('/qzpp')
          break
        case '意见反馈':
          this.$message.info('功能正在维护中')
          break
        default:
          break
      }
      this.$emit('menu-select', item)
      this.closeMenu()
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
    switchAccount() {
      // 切换账号逻辑
      this.showUserMenu = false;
      this.$router.push('/store/entry/loginQRCode');
    },
    logout() {
      // 退出登录逻辑
      this.showUserMenu = false;
      // 清除本地存储的用户信息
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      // 重置本地用户信息
      this.localUser = { name: '', avatar: '' };
      // 通知父组件用户已退出
      this.$emit('user-logout');
      this.$message.success('已退出登录');
    },
    handleUserClick() {
      if (this.isLoggedIn) {
        // 已登录状态下切换菜单显示
        this.toggleUserMenu();
      } else {
        // 未登录状态下跳转到登录页面
        this.$router.push('/store/entry/loginPwd');
      }
    },
    handleClickOutside(event) {
      // 检查点击是否在用户信息区域外
      const userInfo = this.$el.querySelector('.user-info');
      if (userInfo && !userInfo.contains(event.target)) {
        this.showUserMenu = false;
      }
    }
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.clickOutside = (e) => {
          if (!el.contains(e.target)) binding.value()
        }
        document.addEventListener('click', el.clickOutside)
      },
      unbind(el) {
        document.removeEventListener('click', el.clickOutside)
      }
    }
  }
}
</script>

<style scoped>
.user-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  z-index: 9999;
  pointer-events: none;
}

.hamburger {
  position: absolute;
  top: 29px;
  left: 43px;
  pointer-events: auto;
}

.hamburger-btn {
  width: 35px;
  height: 35px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: 0 2px 9px rgba(0, 0, 0, .08);
  cursor: pointer;
  transition: all .16s ease;
}

.hamburger-btn:hover {
  border-color: #0071e3;
  box-shadow: 0 4.8px 19.2px rgba(0, 113, 227, .25);
}

.line {
  width: 19px;
  height: 2px;
  background: #1d1d1f;
  border-radius: 2px;
}

.dropdown {
  position: absolute;
  top: 48px;
  left: 0;
  min-width: 144px;
  background: #EDEEF3;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, .12);
  list-style: none;
  margin: 0;
  padding: 0;
}

.dropdown li {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.dropdown li:hover {
  background: #f2f5ff;
}

.icon-left {
  width: 14px;
  height: 14px;
  margin-right: 10px;
  flex-shrink: 0;
}

.txt {
  flex: 1;
}

.icon-right {
  width: 11px;
  height: 11px;
  flex-shrink: 0;
  opacity: .5;
}

.user-info {
  position: absolute;
  top: 29px;
  right: 43px;
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 43px;
  padding: 0 15px 0 5px;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 22px;
  box-shadow: 0 2px 9px rgba(0, 0, 0, .08);
  cursor: pointer;
  transition: all .16s ease;
}

.user-info:hover {
  border-color: #0071e3;
  box-shadow: 0 4.8px 19.2px rgba(0, 113, 227, .25);
}

.avatar-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
}

.text {
  font-size: 17px;
  font-weight: 600;
  color: #1d1d1f;
}

.el-icon-arrow-down {
  transition: transform 0.3s ease;
  font-size: 12px;
  color: #666;
  margin-left: 5px;
}

.el-icon-arrow-down.rotate {
  transform: rotate(180deg);
}

.user-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-width: 120px;
  z-index: 1001;
  margin-top: 8px;
}

.user-dropdown-menu::before {
  content: '';
  position: absolute;
  top: -6px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #e4e7ed;
}

.user-dropdown-menu::after {
  content: '';
  position: absolute;
  top: -5px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-size: 14px;
  color: #333;
}

.menu-item:hover {
  background-color: #f5f7fa;
}

.menu-item i {
  font-size: 16px;
  color: #666;
}

.menu-item:first-child {
  border-radius: 6px 6px 0 0;
}

.menu-item:last-child {
  border-radius: 0 0 6px 6px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .16s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>